import Dexie, { type Table } from 'dexie'
import { type VideoCrop, type Clip, type ZoomRegion, type PerspectiveType, type AnimationType, type CameraLayer, type CursorSettings } from '@/store/editor-store'
import { type MouseEvent as RecordingMouseEvent } from '@/store/recording-store'

export interface Project {
    id: string
    name: string
    createdAt: number
    lastModified: number
    videoBlob?: Blob
    cameraBlob?: Blob
    duration?: number

    // Editor State
    aspectRatio: string
    backgroundValue: string
    backgroundType: 'solid' | 'gradient' | 'image'
    padding: number
    borderRadius: number
    shadow: string
    perspective: PerspectiveType
    borderWidth: number
    borderColor: string
    borderOpacity: number
    animationIn: AnimationType
    animationOut: AnimationType
    cameraLayer?: CameraLayer

    // Timeline State
    zoomRegions: ZoomRegion[]
    clips: Clip[]
    videoCrop: VideoCrop | null

    // Cursor / Recording State
    mouseData?: RecordingMouseEvent[]
    isDesktop?: boolean
    isExtension?: boolean
    cursorSettings?: CursorSettings
}

export class ScreenRecordDB extends Dexie {
    projects!: Table<Project>

    constructor() {
        super('ScreenRecordDB')
        this.version(1).stores({
            projects: 'id, name, createdAt, lastModified'
        })
    }
}

export const db = new ScreenRecordDB()
